import api from '../../services/api';
import { Creators } from '../ducks/regional_unit';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getRegionalUnits({ filter }) {
  try {
    let response; 

    yield put(Creators.regionalUnitRequest());
    response = yield call(api.post, 'regional-unit', filter);

    yield put(Creators.regionalUnitSuccess(filter.chip, response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.regionalUnitError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao buscar unidades regionais'
    }));
  }
} 